import React from "react";

import { faPlay } from "@fortawesome/pro-regular-svg-icons";
import { useWatch } from "react-hook-form";

import { Button } from "src/base-components/Button";
import { PreviewQueryRequestEnvironmentEnum } from "src/clients/features-control";
import { UseFeatureQueryPreview } from "src/featureCatalogue/queries";
import { useCapabilities } from "src/hooks/useCapabilities";

export const RunQueryButton: React.FC<{
  featurePreview: UseFeatureQueryPreview;
  disabled?: boolean;
  onRunQuery: (environment: PreviewQueryRequestEnvironmentEnum) => void;
}> = ({ featurePreview, disabled, onRunQuery }) => {
  const { featureQueriesCatalogue } = useCapabilities();

  const queryString = useWatch({ name: "query" });

  const isLiveQueryRunning =
    featurePreview.isPending &&
    featurePreview.variables?.environment ===
      PreviewQueryRequestEnvironmentEnum.LIVE;

  const isSandboxQueryRunning =
    featurePreview.isPending &&
    featurePreview.variables?.environment ===
      PreviewQueryRequestEnvironmentEnum.SANDBOX;

  return (
    <div className="flex w-full justify-start gap-x-4">
      <Button
        dataLoc="run-query-button-sandbox"
        disabled={
          !queryString.length ||
          disabled ||
          featurePreview.isPending ||
          !featureQueriesCatalogue.canPreviewSandbox
        }
        iconLeft={faPlay}
        loading={isSandboxQueryRunning}
        variant="secondary"
        onClick={() => {
          if (!featurePreview.isPending) {
            onRunQuery(PreviewQueryRequestEnvironmentEnum.SANDBOX);
          }
        }}
      >
        Run Query in Sandbox
      </Button>
      <Button
        dataLoc="run-query-button-live"
        disabled={
          !queryString.length ||
          disabled ||
          featurePreview.isPending ||
          !featureQueriesCatalogue.canPreviewLive
        }
        iconLeft={faPlay}
        loading={isLiveQueryRunning}
        variant="secondary"
        onClick={() => {
          if (!featurePreview.isPending) {
            onRunQuery(PreviewQueryRequestEnvironmentEnum.LIVE);
          }
        }}
      >
        Run Query in Live
      </Button>
    </div>
  );
};
